import { sprintf } from 'sprintf-js';

import type { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { Text } from 'components/Text/Text';
import { ClientOnly } from 'containers/ClientOnly';
import { distanceInWordsToNow } from 'utils/date';

type Props = {
  listingFirstPublished: ApiISODateTimeString;
  isNew: boolean;
};

export function ListingViewHeaderPublishedTag({
  listingFirstPublished,
  isNew,
}: Props) {
  return (
    <>
      {isNew && (
        <div>
          <Text
            fontWeight="semiBold"
            color="mediumContentGrey"
            borderBottom="4px solid"
            borderColor="brandYellow"
            display="inline-block"
            lineHeight="6px"
            ml="0px"
            mr="12px"
            p="0px"
          >
            {getText('New')}
          </Text>
        </div>
      )}

      <Text display="inline-block" color="lightContentGrey">
        <ClientOnly>
          {
            /* TRANSLATORS: Listing page - time published */
            sprintf(getText('Published %(timeAgo)s'), {
              timeAgo: distanceInWordsToNow(listingFirstPublished),
            })
          }
        </ClientOnly>
      </Text>
    </>
  );
}
